import { bridge } from '@sloyd/viewer';
import { Group } from '@tweenjs/tween.js';
import { delay, guid4, ROOT_OUTPUT } from 'shared-base';
import { Mesh, Object3D, Scene } from 'three';
import { randomize, spin } from '../extra/extra.utils';

export let scene: Scene | null = null;
export const tweenGroup = new Group(); // Manage tween animations

export const setScene = (value: Scene) => {
  scene = value;
};

export const show = (id: string) => {
  hideAll();
  showMesh(id);
};

export const showMesh = (id: string) => {
  if (!scene) {
    console.warn('Scene is not set. Call setScene() before using getMesh().');
    return;
  }

  scene.traverse((child: Object3D) => {
    if (child instanceof Mesh && child.userData.id === id) {
      child.visible = true;
    }
  });
};

export const hideAll = () => {
  if (!scene) {
    console.warn('Scene is not set. Call setScene() before using hideAll().');
    return;
  }

  scene.traverse((child: Object3D) => {
    if (child instanceof Mesh && child.userData.id) {
      child.visible = false;
    }
  });
};

export const generatorToModel = (generator: IGenerator, palettes: IPalettes) => {
  const guid = guid4();

  const { name, paletteId, defaultValues = {} } = generator;
  let materials = {};

  if (paletteId) {
    const palette = Object.values(palettes || {}).find((p) => p.id === paletteId);
    materials = palette?.materials ?? {};
  }

  const model = {
    id: guid,
    name,
    generatorId: generator.id,
    generatorUrl: `${ROOT_OUTPUT}/${generator.id}.template.json`,
    thumbnail: '',
    modifiedAt: new Date().toISOString(),
    valuesModel: { ...defaultValues, LOD: 0.5 },
    materials,
    paletteId,
  };

  return model as Partial<IModel>;
};

export const startTour = async (
  instanceId: string,
  generator: IGenerator,
  palettes: IPalettes,
  stepDuration: number = 1000,
  steps: number = 5
) => {
  const totalDuration = stepDuration * steps;

  const model: any = generatorToModel(generator, palettes) as IModel;

  bridge.replaceModel('main', model);
  await delay(50);
  bridge.cameraFocus('main');
  await delay(200);
  spin(instanceId, totalDuration);

  for (let i = 0; i < steps; i++) {
    const values = randomize(generator.parameters);
    bridge.patchValuesModel('main', values);
    await delay(stepDuration);
  }
};
